import { logEvent } from 'features/analytics';
import { CustomEventNames, EventTypes } from 'features/analytics/constants';
import { TLogSupportFormSubmission } from 'features/support/core/types';

export const logSupportFormSubmission: TLogSupportFormSubmission = ({
  userIssue,
  formData,
  caseRefNumber,
}) => {
  logEvent(CustomEventNames.SUPPORT_FORM_SUBMIT, EventTypes.Other, {
    'Issue ID': userIssue ? userIssue.knowledgeForceIssueId : 'No Issue Id',
    'Issue Name': userIssue ? userIssue?.name?.locale : 'Untitled',
    'Issue Description': formData.comments,
    'Marketforce Reference': caseRefNumber,
  });
};

export const logSupportNavigationDecision = (message: string, orderId?: string) => {
  logEvent(CustomEventNames.SUPPORT_FORM_NAVIGATION_DECISION, EventTypes.Navigation, {
    message: `Orders List Page: ${message}`,
    orderId,
  });
};

export const logSupportFaqInteraction = (eventName: string) => {
  logEvent(eventName, EventTypes.Other);
};
